import { render, staticRenderFns } from "./selaSalesEachTypes.vue?vue&type=template&id=87dbc324&scoped=true"
import script from "./selaSalesEachTypes.vue?vue&type=script&lang=js"
export * from "./selaSalesEachTypes.vue?vue&type=script&lang=js"
import style0 from "./selaSalesEachTypes.vue?vue&type=style&index=0&id=87dbc324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dbc324",
  null
  
)

export default component.exports